/*
 * PhotoHouse / unpublished preview / 2026-11-02
 * Return empty-cart "Continue browsing" to this tab's latest public
 * storefront page instead of the obsolete /collections/all route.
 * Uses only this tab's sessionStorage; no customer data or Shopify cart API.
 */
(function () {
  'use strict';
  var KEY = 'ph-preview:last-browsing-url';

  function validPage(path) {
    var clean = (path || '').replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
    if (/^\/collections\/all(?:\/|$)/i.test(clean)) return false;
    return clean === '/' || /^\/(?:products|collections|pages|blogs|search)(?:\/|$)/i.test(clean);
  }

  function validInternalUrl(value) {
    if (!value) return null;
    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || !validPage(url.pathname)) return null;
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return null;
    }
  }

  function readSaved() {
    try { return validInternalUrl(window.sessionStorage.getItem(KEY)); }
    catch (e) { return null; }
  }

  function save(url) {
    try { window.sessionStorage.setItem(KEY, url); }
    catch (e) { /* A disabled storage setting should not break navigation. */ }
  }

  // Remember the product, collection, search, home or editorial page the
  // visitor was browsing before the cart opened. Never replace it with /cart.
  if (validPage(window.location.pathname)) {
    save(window.location.href);
  } else if (!readSaved()) {
    var ref = validInternalUrl(document.referrer);
    if (ref) save(new URL(ref, window.location.origin).href);
  }

  function destination(anchor) {
    return readSaved() || validInternalUrl(document.referrer) ||
      (anchor && anchor.getAttribute('href')) || '/';
  }

  document.addEventListener('click', function (event) {
    var element = event.target;
    if (!element || !element.closest) return;
    var anchor = element.closest('a[data-ph-continue-shopping]');
    if (!anchor) return;

    var target = destination(anchor);
    event.preventDefault();

    // A cart drawer opened on a product page: close it via Kingdom's native
    // close handler instead of reloading the same product page.
    var drawer = anchor.closest('.sidebar__cart');
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (drawer && target === current) {
      var close = drawer.querySelector('.sidebar__cart-close');
      if (close && typeof close.click === 'function') {
        close.click();
        return;
      }
    }
    window.location.assign(target);
  });
}());
